import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {getButtonsData} from 'src/common/helpers'
import type {Context} from 'src/common/types'
import {CentralMediaSection} from './CentralMediaSection'

export type CentralMediaSectionProps = SliceComponentProps<Content.CentralMediaSectionSlice>

const CentralMediaSectionSlice = ({
  slice,
  context: {pageUid, buttonsData},
}: CentralMediaSectionProps & {context: Context}): JSX.Element | null => {
  switch (slice.variation) {
    case 'default': {
      const {primaryButtonData} = getButtonsData({buttonsData, primaryButton: slice.primary.button})
      const badge = slice.primary.badge[0]

      return (
        <CentralMediaSection
          backgroundImage={slice.primary.background_image}
          backgroundMode={slice.primary.background_mode}
          badgeIcon={badge?.icon ?? null}
          badgeIconColor={badge?.icon_color ?? null}
          badgeText={isFilled.keyText(badge?.text) ? badge.text : ''}
          heading={isFilled.keyText(slice.primary.heading) ? slice.primary.heading : ''}
          headingAccent={isFilled.keyText(slice.primary.heading_accent) ? slice.primary.heading_accent : ''}
          description={isFilled.keyText(slice.primary.description) ? slice.primary.description : ''}
          buttonData={primaryButtonData}
          mainImage={slice.primary.main_image}
          chatQuestion={isFilled.keyText(slice.primary.chat_question) ? slice.primary.chat_question : ''}
          statCards={slice.primary.stat_cards
            .filter((card) => isFilled.keyText(card.label) || isFilled.keyText(card.amount))
            .map((card) => ({
              label: isFilled.keyText(card.label) ? card.label : '',
              amount: isFilled.keyText(card.amount) ? card.amount : '',
              percentage: isFilled.keyText(card.percentage) ? card.percentage : '',
              trend: card.trend === 'Down' ? 'Down' : 'Up',
            }))}
          pageUid={pageUid}
          paddingTop={slice.primary.padding_top}
          paddingBottom={slice.primary.padding_bottom}
        />
      )
    }

    default:
      return null
  }
}

export default CentralMediaSectionSlice
